module.exports = __webpack_public_path__ + "4c078a2e18e71596acd4ec0851589e65.jpg";